// Work data
//
// Live = publicly accessible, deployed projects (real Visit links).
// Enterprise = flagship production work delivered through private company
// repositories, so shown without public source links.

export const Live = [
    {
        id: "roha",
        name: "Roha Labs — My Company",
        description:
            "My software studio's corporate website — engineering carrier-grade telecom platforms (the Nova Suite — USSD, SMS, charging) and AI-assisted health & education systems. Designed and built end-to-end.",
        tags: ["Next.js", "Three.js", "Framer Motion", "Telecom"],
        url: "https://roha-labs.vercel.app",
    },
    {
        id: "mesa",
        name: "Mesa — Restaurant OS",
        description:
            "Full point-of-sale and operations platform for restaurants — orders, kitchen display, bar management, billing and staff administration across stations.",
        tags: ["Next.js", "Drizzle ORM", "TanStack", "Better Auth"],
        url: "https://restaurant.bz-solutions.com",
    },
    {
        id: "adlaunch",
        name: "AdLaunch ET",
        description:
            "Digital advertising & rewards platform with a custom Ad Engine — campaign orchestration, audience targeting and airtime/data reward distribution over telecom SDP.",
        tags: ["Next.js", "Node.js", "SMPP", "Chapa"],
        url: "https://adlaunch-next.vercel.app",
    },
    {
        id: "eshop",
        name: "Multi-Vendor E-Shop",
        description:
            "Multi-vendor e-commerce platform built on the MERN stack with real-time updates, vendor dashboards and order management.",
        tags: ["MERN", "Socket.io", "Redux"],
        url: "https://e-shop-mern-rho.vercel.app",
    },
    {
        id: "karismed-sales",
        name: "Karismed Pharmacy — Sales",
        description:
            "Pharmacy sales and inventory portal for Karismed — point-of-sale, stock control and reporting for retail pharmacy operations.",
        tags: ["CodeIgniter", "PHP", "MySQL"],
        url: "https://sales.karismed-pharmacy.com/",
    },
    {
        id: "karismed-vita",
        name: "Karismed Vita — Sales",
        description:
            "Dedicated sales and distribution portal for the Karismed Vita product line, sharing the same pharmacy operations engine.",
        tags: ["CodeIgniter", "PHP", "MySQL"],
        url: "https://vita-sales.karismed-pharmacy.com/",
    },
    {
        id: "ledger",
        name: "Digital Ledger",
        description:
            "Mini-application demo for digital financial record-keeping — secure tracking and management of transactions and balances.",
        tags: ["Next.js", "FinTech", "Mini App"],
        url: "https://digital-ledger-platform-ysg7.vercel.app/",
    },
    {
        id: "ethiodevs",
        name: "Ethio Devs",
        description:
            "A platform for the Ethiopian software development community — resources and a home for local developers.",
        tags: ["Next.js", "Community"],
        url: "https://ethio-devs.vercel.app/",
    },
    {
        id: "sydro",
        name: "Sydro",
        description:
            "The live platform of Sydro, where I currently work as a Backend Developer — building and scaling the services, APIs and data layer behind the product.",
        tags: ["Backend", "APIs", "Current role"],
        url: "https://www.sydro.live/",
    },
]

export const Enterprise = [
    {
        id: "ibex",
        name: "IBEX USSD & Messaging Platform",
        featured: true,
        description:
            "Core USSD & messaging platform powering self-service, M-PESA financial services and enterprise integrations for millions of Safaricom Ethiopia subscribers. My flagship telecom platform — recognized by Safaricom Group leadership.",
        tags: ["Spring Boot", "Node.js", "MongoDB", "Dragonfly", "M-PESA"],
    },
    {
        id: "superapp",
        name: "Digital Lifestyle Super App",
        description:
            "Telecom-agnostic super app with a mini-app framework, centralized game engine and local + international payment integrations (M-PESA, Stripe, Play & App Store).",
        tags: ["Flutter", "Next.js", "Nakama", "Stripe", "Kubernetes"],
    },
    {
        id: "trivia",
        name: "SMS Trivia Platform",
        description:
            "SMS-based customer engagement platform serving 200k+ daily participants, integrated with telecom charging, CRM, BSS and SDP systems.",
        tags: ["Angular", "Node.js", "RabbitMQ", "Charging GW"],
    },
    {
        id: "azzly",
        name: "AZZLY Rize",
        description:
            "Healthcare & telemedicine platform used across the US — led the Angular 7 → 9 migration and built patient, clinical and telemedicine workflows.",
        tags: ["Angular", "TypeScript", "REST"],
    },
    {
        id: "omnidantis",
        name: "OmniDantis Marketplace",
        description:
            "Investment & venture engagement platform connecting entrepreneurs and investors to publish opportunities, negotiate stakes and fund initiatives.",
        tags: ["Angular", "Spring Boot", "MySQL", "AWS"],
    },
]

export const Profiles = [
    { label: "GitHub", url: "https://github.com/bereket-09" },
    { label: "Arc.dev", url: "https://arc.dev/@bereketyezelalem?preview=1" },
]
